/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateEntityInput = {
  type: EntityType,
  detail: string,
  shift: string,
  department: string,
  photo?: string | null,
  owner?: string | null,
  date?: string | null,
  process?: string | null,
  ecd?: string | null,
  category?: string | null,
  modifyDate?: string | null,
  updateDetail?: string | null,
  progress?: string | null,
  innovator?: string | null,
  priority?: string | null,
};

export enum EntityType {
  SUCCESS = "SUCCESS",
  SAFETY = "SAFETY",
  BARRIER = "BARRIER",
  PROJECT = "PROJECT",
}


export type EntityResult = {
  __typename: "EntityResult",
  success: boolean,
  message?: string | null,
  entity?: Entity | null,
  siteId?: string | null,
};

export type Entity = SUCCESS | SAFETY | BARRIER | PROJECT


export type SUCCESS = {
  __typename: "SUCCESS",
  id: string,
  detail: string,
  type: EntityType,
  shift: string,
  department: string,
  photo?: string | null,
  owner: string,
  date: string,
};

export type SAFETY = {
  __typename: "SAFETY",
  id: string,
  detail: string,
  type: EntityType,
  shift: string,
  department: string,
  photo?: string | null,
  date: string,
  ecd: string,
  owner: string,
};

export type BARRIER = {
  __typename: "BARRIER",
  id: string,
  detail: string,
  type: EntityType,
  shift: string,
  department: string,
  photo?: string | null,
  owner: string,
  process: string,
  date: string,
  ecd: string,
  category: string,
  modifyDate: string,
  updateDetail: string,
  progress: string,
  priority?: string | null,
};

export type PROJECT = {
  __typename: "PROJECT",
  id: string,
  detail: string,
  type: EntityType,
  shift: string,
  department: string,
  photo?: string | null,
  owner: string,
  innovator: string,
  process: string,
  date: string,
  ecd: string,
  modifyDate: string,
  updateDetail: string,
  progress: string,
  priority?: string | null,
};

export type UpdateEntityInput = {
  detail?: string | null,
  shift?: string | null,
  department?: string | null,
  photo?: string | null,
  owner?: string | null,
  date?: string | null,
  process?: string | null,
  ecd?: string | null,
  category?: string | null,
  modifyDate?: string | null,
  updateDetail?: string | null,
  progress?: string | null,
  innovator?: string | null,
  priority?: string | null,
};

export type DeleteResult = {
  __typename: "DeleteResult",
  success: boolean,
  message?: string | null,
  siteId?: string | null,
  type?: string | null,
  id?: string | null,
};

export type EntitiesResult = {
  __typename: "EntitiesResult",
  success: boolean,
  message?: string | null,
  entities?:  Array<Entity > | null,
  siteId?: string | null,
  nextToken?: string | null,
};

export type CreateEntityMutationVariables = {
  siteId: string,
  input: CreateEntityInput,
};

export type CreateEntityMutation = {
  createEntity:  {
    __typename: "EntityResult",
    success: boolean,
    message?: string | null,
    entity: ( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) | null,
    siteId?: string | null,
  },
};

export type UpdateEntityMutationVariables = {
  siteId: string,
  id: string,
  type: EntityType,
  input: UpdateEntityInput,
};

export type UpdateEntityMutation = {
  updateEntity:  {
    __typename: "EntityResult",
    success: boolean,
    message?: string | null,
    entity: ( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) | null,
    siteId?: string | null,
  },
};

export type DeleteEntityMutationVariables = {
  siteId: string,
  type: string,
  id: string,
};

export type DeleteEntityMutation = {
  deleteEntity:  {
    __typename: "DeleteResult",
    success: boolean,
    message?: string | null,
    siteId?: string | null,
    type?: string | null,
    id?: string | null,
  },
};

export type GetEntityQueryVariables = {
  siteId: string,
  type: string,
  entityId: string,
};

export type GetEntityQuery = {
  getEntity:  {
    __typename: "EntityResult",
    success: boolean,
    message?: string | null,
    entity: ( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) | null,
    siteId?: string | null,
  },
};

export type GetEntitiesQueryVariables = {
  siteId: string,
  shift: string,
  department: string,
  type: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetEntitiesQuery = {
  getEntities:  {
    __typename: "EntitiesResult",
    success: boolean,
    message?: string | null,
    entities:  Array<( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) > | null,
    siteId?: string | null,
    nextToken?: string | null,
  },
};

export type GetEntitiesByDateRangeQueryVariables = {
  siteId: string,
  startDate: string,
  endDate: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetEntitiesByDateRangeQuery = {
  getEntitiesByDateRange:  {
    __typename: "EntitiesResult",
    success: boolean,
    message?: string | null,
    entities:  Array<( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) > | null,
    siteId?: string | null,
    nextToken?: string | null,
  },
};

export type CreatedEntitySubscriptionVariables = {
  siteId: string,
};

export type CreatedEntitySubscription = {
  createdEntity?:  {
    __typename: "EntityResult",
    success: boolean,
    message?: string | null,
    entity: ( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) | null,
    siteId?: string | null,
  } | null,
};

export type UpdatedEntitySubscriptionVariables = {
  siteId: string,
};

export type UpdatedEntitySubscription = {
  updatedEntity?:  {
    __typename: "EntityResult",
    success: boolean,
    message?: string | null,
    entity: ( {
        __typename: "SUCCESS",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        date: string,
      } | {
        __typename: "SAFETY",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        date: string,
        ecd: string,
        owner: string,
      } | {
        __typename: "BARRIER",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        process: string,
        date: string,
        ecd: string,
        category: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      } | {
        __typename: "PROJECT",
        id: string,
        detail: string,
        type: EntityType,
        shift: string,
        department: string,
        photo?: string | null,
        owner: string,
        innovator: string,
        process: string,
        date: string,
        ecd: string,
        modifyDate: string,
        updateDetail: string,
        progress: string,
        priority?: string | null,
      }
    ) | null,
    siteId?: string | null,
  } | null,
};

export type DeletedEntitySubscriptionVariables = {
  siteId: string,
};

export type DeletedEntitySubscription = {
  deletedEntity?:  {
    __typename: "DeleteResult",
    success: boolean,
    message?: string | null,
    siteId?: string | null,
    type?: string | null,
    id?: string | null,
  } | null,
};
